export default __webpack_public_path__ + "static/media/gallstone.814c385d.svg";